"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
exports.default = () => core_1.createStyles({});
//# sourceMappingURL=styles.js.map